import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null, cabangId = null, expenseType = null, month = null, year = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-expense?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${cabangId ? '&cabang_id=' + cabangId : ''}` +
        `${expenseType ? '&expense_type=' + expenseType : ''}` +
        `${month ? '&month=' + month : ''}` +
        `${year ? '&year=' + year : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'operational-expense', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'operational-expense/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'operational-expense/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'operational-expense/' + id).then((response) => {
    return response.data;
  });
};

const uploadReceipt = async (id, data) => {
  return http_client.post(config.apiUrl + 'operational-expense/' + id + '/upload-receipt', data).then((response) => {
    return response.data;
  });
};

const deleteReceipt = async (id, fileId) => {
  return http_client.delete(config.apiUrl + 'operational-expense/' + id + '/receipt/' + fileId).then((response) => {
    return response.data;
  });
};

const checkBalance = async (cabangId, nominal) => {
  return http_client
    .get(config.apiUrl + 'operational-expense/check-balance?cabang_id=' + cabangId + '&nominal=' + nominal)
    .then((response) => {
      return response.data;
    });
};

const getHistory = async (cabangId, page = null, perPage = null, month = null, year = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-expense/history/' +
        cabangId +
        '?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${month ? '&month=' + month : ''}` +
        `${year ? '&year=' + year : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null, cabangId = null, expenseType = null, startDate = null, endDate = null, createdBy = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-expense/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${cabangId ? '&cabang_id=' + cabangId : ''}` +
        `${expenseType ? '&expense_type=' + expenseType : ''}` +
        `${startDate ? '&start_date=' + startDate : ''}` +
        `${endDate ? '&end_date=' + endDate : ''}` +
        `${createdBy ? '&created_by=' + createdBy : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const changeStatus = async (id, status) => {
  return http_client.post(config.apiUrl + 'operational-expense/status/' + id, { status }).then((response) => {
    return response.data;
  });
};

const permanentDelete = async (id) => {
  return http_client.delete(config.apiUrl + 'operational-expense/permanent/' + id).then((response) => {
    return response.data;
  });
};

const PengeluaranOperasionalService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  uploadReceipt,
  deleteReceipt,
  checkBalance,
  getHistory,
  changeStatus,
  permanentDelete
};

export default PengeluaranOperasionalService;

